
















import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import { serverBase } from "@/apollo";

@Component
export default class About extends Vue {
  showLog = false;
  showHttp = false;
  showWarn = true;

  logs = [] as any[];

  get filtered() {
    let logs = this.logs;

    if (!this.showHttp) logs = logs.filter(l => l.type != "http");
    if (!this.showLog) logs = logs.filter(l => l.type != "log");
    if (!this.showWarn) logs = logs.filter(l => l.type != "warn");
    return logs;
  }

  fontColor(type: string) {
    return {
      log: "#60b0ff",
      error: "#ff3040",
      http: "#aaaaff",
      warn: "#ffdd66",
      message: "#ffffff",
      success: "#aaff85"
    }[type];
  }

  mounted() {
    Axios.get(`${serverBase}/log?password=${localStorage.getItem("password")}`)
      .then(({ data }) => {
        this.logs = data;
      })
      .catch(err => {
        console.error(err);
      });
  }
}
